import {
  Backend,
  getQueryParamValue,
  OrderByDirection,
} from '@freelancer/datastore/core';
import { SearchActiveProjectsCollection } from './search-active-projects.types';

export function searchActiveProjectsBackend(): Backend<
  SearchActiveProjectsCollection
> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.DESC,
    }, // This endpoint is only used with search queries so doesn't need an ordering

    fetch: (authUid, ids, query, order) => ({
      endpoint: `projects/0.1/projects/active`,
      params: {
        query: query?.searchQueryParams?.query || query?.searchQueryParams?.q,
        jobs: getQueryParamValue(query, 'skillIds')[0],
        full_description: 'true',
        job_details: 'true',
        offset: query?.searchQueryParams?.offset,
        upgrade_details: 'true',
      },
    }),
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
